import state from "frontend/state/main"

export default (...args) => {
  return args.reduce((s, k) => (s ? s[k] : s), state)
}
